import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { CustomErrorMessage } from '@/components/common/Form';
import { onboardingConstants } from '@/lib';

const { WOTC_TAX_SURVEY_TEXT, WOTC_SURVEY, WOTC_SURVEY_COMPLETED } = onboardingConstants;

const WotcSurvey = ({ canEditField }) => {
  const { setValue, formState: { errors } } = useFormContext();

  const onClickSurvey = (event) => {
    if (!canEditField(WOTC_SURVEY_COMPLETED)) {
      event.preventDefault();

      return;
    }

    setValue(WOTC_SURVEY_COMPLETED, true, { shouldValidate: true });
  };

  return (
    <div className="border-gray-200">
      <div className="">
        <div>
          *
          {WOTC_SURVEY}
          <div className="text-sm text-red-500">Please ensure to left click only on this link</div>
        </div>
        <div className="flex border rounded-md">
          <div className="px-2 py-2 border-r text-gray-500 bg-gray-100">https://</div>
          <div className="px-2 py-2">
            <a className="text-blue-500 bg-blue"
              target="_blank"
              href="https://wotc.oncentive.com/applicants-form/clws2e8vi00290al631k01pnq"
              onClick={onClickSurvey}
              rel="noreferrer"
            >
              wotc.oncentive.com/applicants-form/clws2e8vi00290al631k01pnq
            </a>
          </div>
        </div>
        <div className="text-sm pt-3">{WOTC_TAX_SURVEY_TEXT}</div>
        {errors?.wotcSurveyCompleted?.message && (
          <CustomErrorMessage text={errors?.wotcSurveyCompleted?.message} />
        )}
      </div>
    </div>
  );
};

WotcSurvey.propTypes = {
  canEditField: PropTypes.func,
};

export default WotcSurvey;
